import styled, { css } from 'styled-components';

export const ImageContainer = styled.div<{
  isHero?: boolean;
}>`
  display: flex;

  ${({ isHero }) =>
    isHero &&
    css`
      flex: 3;
      img {
        width: 100%;
        object-fit: contain;
      }
    `};

  img {
    width: 100%;
  }
`;
